import { render, staticRenderFns } from "./DashboardNav.vue?vue&type=template&id=81a7dd02&"
import script from "./DashboardNav.vue?vue&type=script&lang=js&"
export * from "./DashboardNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81a7dd02')) {
      api.createRecord('81a7dd02', component.options)
    } else {
      api.reload('81a7dd02', component.options)
    }
    module.hot.accept("./DashboardNav.vue?vue&type=template&id=81a7dd02&", function () {
      api.rerender('81a7dd02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/partials/DashboardNav.vue"
export default component.exports